import { useCallback, useEffect, useState } from 'react';

function useParticipantChanged({ zoomClient }) {
  const [participants, setParticipants] = useState([]);

  const getCurrentUserId = useCallback(
    () => zoomClient?.getCurrentUserInfo()?.userId,
    [zoomClient],
  );

  const getCurrentUserParticipant = useCallback(() => {
    const currentUserId = getCurrentUserId();
    return participants.find(e => e.userId === currentUserId);
  }, [participants, getCurrentUserId]);

  const getOtherUserParticipant = useCallback(() => {
    const currentUserId = getCurrentUserId();
    return participants.find(
      e =>
        e.userId !== currentUserId &&
        e.userIdentity !== zoomClient?.getCurrentUserInfo()?.userIdentity,
    );
  }, [participants, getCurrentUserId, zoomClient]);

  const updateParticipants = useCallback(() => {
    setParticipants(zoomClient.getAllUser());
  }, [zoomClient]);

  useEffect(() => {
    if (!zoomClient) return;
    zoomClient.on('user-updated', updateParticipants);
    zoomClient.on('user-added', updateParticipants);
    zoomClient.on('user-removed', updateParticipants);
    return () => {
      zoomClient.off('user-updated', updateParticipants);
      zoomClient.off('user-added', updateParticipants);
      zoomClient.off('user-removed', updateParticipants);
    };
  }, [updateParticipants, zoomClient]);

  return {
    participants,
    getCurrentUserParticipant,
    getOtherUserParticipant,
  };
}

export default useParticipantChanged;
